<template>
    <div>
        <div v-if="!edit_mode_lock" class="form-mode-toggle">
            <el-switch
                v-model="internalEditMode"
                active-text="Edit Mode"
                inactive-text="View Mode">
            </el-switch>
        </div>
        <el-form :model="keyValues()" :rules="rules" ref="theForm" class="theForm">
            <div v-for="field_definition in orderedPretty">
              <div v-if="field_definition.display">
                <div v-if="!field_definition.condition || conditionCheck(rawPretty[field_definition.condition.field_name].value,field_definition.condition.field_value)">
                            <component
                                    :is="field_definition.value_type === 'section' || field_definition.value_type === 'image' ? 'form_' + field_definition.value_type  : field_definition.value_type"
                                    :elementDefinition="field_definition"
                                    :initialValue="field_definition.value"
                                    :edit_mode="internalEditMode"
                                    @handleFormElementValueChange="handleFormElementValueChange" />
                </div>
              </div>
            </div>
            <div v-if="internalEditMode">
                <div style="margin-top:30px; padding-top:20px;border-top:1px solid">
                    <span v-for="event in events" style="margin-right:20px" >
                        <el-button @click="handleEventButtonClick(event.event)">{{ event.label }}</el-button>
                    </span>
                </div>
                <div v-if="resubmitMode">
                    <p style="color:red;">Correct values (see errors highlighted in red)</p>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import FormElementList from "./FormElementList";
    import FormElementBoolean from "./FormElementBoolean";
    import FormElementInteger from "./FormElementInteger";
    import FormElementShortText from "./FormElementShortText";
    import FormElementLongText from "./FormElementLongText";
    import FormElementSection from "./FormElementSection";
    import FormElementRadio from "./FormElementRadio";
    import FormElementImage from "./FormElementImage";

    export default {
        name: "FormManager",
        components: {
            list: FormElementList,
            boolean: FormElementBoolean,
            integer: FormElementInteger,
            shortText: FormElementShortText,
            form_section: FormElementSection,
            radio: FormElementRadio,
            longText: FormElementLongText,
            form_image: FormElementImage, // cannot use the built in "image"
        },
        props: [
            'prettyEndPoint',       // endPoint to get the prettyFormDefinition (how the form elements look and behave)
            'events',               // define the events to submit and the text of the buttons that should trigger the events
            'initialFormValues',    // values of the form fields when the form is initially opened
            'edit_mode',            // whether the form is in edit (true, default) or read-only (false) mode
            'edit_mode_lock'        // whether the user can control the edit/read-only toggle
        ],
        mounted() {
            this.getRaw()
            this.internalEditMode = this.edit_mode !== undefined ? this.edit_mode : true
        },
        computed: {
            orderedPretty: function () {
                if (this.rawPretty) {
                    let asArray = Object.values(this.rawPretty)
                    let filtered = asArray.filter(p => p.display)
                    let sorted = filtered.sort(p => p.order)
                    return sorted
                } else {
                    return null
                }
            },
            rules: function() {
                if (this.rawPretty) {
                    let rules = {}
                    for (const element_key in this.rawPretty) {
                        let objectWithRule = this.rawPretty[element_key]
                        if (objectWithRule.value_type !== 'section') {
                            let field_name = objectWithRule.key
                            rules[field_name] = objectWithRule.rule
                        }
                    }
                    return rules
                } else {
                    return null
                }
            }
        },
        watch: {
            initialFormValues: function() {
                this.getRaw()
            },
            edit_mode: function(val) {
                this.internalEditMode = val !== undefined ? val : true
            }
        },
        data() {
            return {
                rawPretty: null,
                valuesChangedSinceInitialOrLastEvent: false,
                resubmitMode: false,
                internalEditMode: true
            }
        },
        methods: {
            conditionCheck(actual_value,desired_value) {
              console.log('about to compare ' + actual_value + ' with ' + desired_value)
              var possible_values = desired_value.split('|')
              let return_value = false
              possible_values.forEach((possible_value) => {
                if (actual_value === possible_value) {
                  return_value = true
                }
              })
              return return_value;
            },
            keyValues: function() {
                console.log('keyValues change!')
                if (this.rawPretty) {
                    let valuesOnly = {}
                    for (const element_key in this.rawPretty) {
                        let objectWithValue = this.rawPretty[element_key]
                        if (objectWithValue.value_type!=='section') {
                            let field_name = objectWithValue.key
                            valuesOnly[field_name] = objectWithValue['value']
                        }
                    }
                    return valuesOnly
                } else {
                    return null
                }
            },
            sleep(milliseconds) {
                return new Promise(resolve => setTimeout(resolve, milliseconds))
            },
            setResubmitMode() {
              this.resubmitMode = true
            },
            getRaw() {
                axios.get(this.prettyEndPoint)
                    .then(response => {
                        this.rawPretty = response.data
                        let values = this.initialFormValues
                        for (const element_key in this.rawPretty) {
                            let element = this.rawPretty[element_key]
                            if (values && values[element_key] !== undefined) {
                                element.value = values[element_key]
                            } else if (element['default'] !== undefined) {
                                element.value = element['default']
                            } else {
                                element.value = null
                            }
                        }
                        this.valuesChangedSinceInitialOrLastEvent = false
                    })
                    .catch(error => {
                        console.log('could not load prettyFormDefinition')
                    })
            },
            handleFormElementValueChange(e) {
                let field_name = e.field_name
              console.log(this.rawPretty)
              console.log(field_name)
                this.rawPretty[field_name].value = e.field_value
                this.valuesChangedSinceInitialOrLastEvent = true
                if (this.resubmitMode) {
                    this.sleep(500).then(() => {
                        this.$refs.theForm.validate((valid) => {
                            if (valid) {
                                console.log('false')
                                this.resubmitMode = false
                            } else {
                                console.log('true')
                                this.setResubmitMode()
                            }
                        });
                    })
                }
                this.$emit('onModify');
            },
            toggleEditMode() {
                this.internalEditMode = !this.internalEditMode
            },
            handleEventButtonClick(event) {
                console.log('in handleEventButtonClick')

                this.$refs.theForm.validate((valid) => {
                    if (valid) {
                        this.$emit(event, this.keyValues(), this.valuesChangedSinceInitialOrLastEvent);
                        this.valuesChangedSinceInitialOrLastEvent = false
                        this.resubmitMode = false
                        console.log('false')
                    } else {
                        this.setResubmitMode()
                        console.log('true')
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>